import React from 'react';
import Calendar from './Calendar';

function Dashboard() {
  // Sample data for dashboard
  const stats = [
    { label: 'Clients', value: '1992' },
    { label: 'Projects in negotiations', value: '31' },
    { label: 'Current Tasks', value: '43' }
  ];
  
  // Sample upcoming events
  const events = [
    { 
      time: 'Today, 10:30 - 11:00', 
      title: 'Project discussion with Jean and Dominic',
      tags: ['UI Design', 'Prototype']
    },
    { 
      time: '16:30-18:00', 
      title: 'Belanja di Supermarket',
      location: '🗺️' 
    }
  ];
  
  // Sample progress data
  const progressData = {
    label: 'Review from client',
    progress: 54.27,
    subtitle: 'Produktivitas 6 minggu terakhir'
  };
  
  return (
    <div className="p-4 md:p-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Left column */}
        <div className="md:col-span-2 space-y-6">
          {/* Stats cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {stats.map((stat, index) => (
              <div key={index} className="dashboard-card">
                <div className="text-sm text-gray-500 mb-1 flex items-center">
                  {index === 0 && (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-indigo-500" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M13 6a3 3 0 11-6 0 3 3 0 016 0zM18 8a2 2 0 11-4 0 2 2 0 014 0zM14 15a4 4 0 00-8 0v3h8v-3zM6 8a2 2 0 11-4 0 2 2 0 014 0zM16 18v-3a5.972 5.972 0 00-.75-2.906A3.005 3.005 0 0119 15v3h-3zM4.75 12.094A5.973 5.973 0 004 15v3H1v-3a3 3 0 013.75-2.906z" />
                    </svg>
                  )}
                  {index === 1 && (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-orange-500" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                    </svg>
                  )}
                  {index === 2 && (
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1 text-pink-500" viewBox="0 0 20 20" fill="currentColor">
                      <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                      <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                    </svg>
                  )}
                  {stat.label}
                </div>
                <div className="text-2xl font-bold text-gray-800">{stat.value}</div>
              </div>
            ))}
          </div>
          
          {/* Month and year */}
          <div className="dashboard-card">
            <div className="text-sm text-gray-500 mb-1">2020</div>
            <div className="text-xl font-bold text-gray-800 mb-4">Agustus</div>
            
            <div className="flex items-center space-x-4">
              {[9, 10, 11, 12, 13, 14].map((day, index) => (
                <div 
                  key={index} 
                  className={`w-10 h-10 flex items-center justify-center rounded-full text-sm ${
                    day === 11 
                      ? 'bg-purple-200 text-purple-800' 
                      : 'text-gray-600 hover:bg-gray-100'
                  }`}
                >
                  {day}
                </div>
              ))}
            </div>
          </div>
          
          {/* Chart placeholder */}
          <div className="chart-container h-40 flex items-center justify-center">
            <div className="flex space-x-4 w-full h-full items-end px-4">
              <div className="h-1/3 w-full bg-indigo-200 rounded-t-lg"></div>
              <div className="h-2/3 w-full bg-indigo-400 rounded-t-lg"></div>
              <div className="h-3/4 w-full bg-indigo-500 rounded-t-lg"></div>
              <div className="h-1/2 w-full bg-indigo-300 rounded-t-lg"></div>
              <div className="h-1/4 w-full bg-indigo-200 rounded-t-lg"></div>
              <div className="h-2/5 w-full bg-indigo-400 rounded-t-lg"></div>
            </div>
          </div>
          
          {/* Week days */}
          <div className="flex justify-between px-2">
            {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => (
              <div key={index} className="text-sm text-gray-500">{day}</div>
            ))}
          </div>
        </div>
        
        {/* Right column */}
        <div className="space-y-6">
          {/* Calendar widget */}
          <div className="dashboard-card">
            <Calendar />
          </div>
          
          {/* Upcoming events */}
          <div className="dashboard-card">
            <h3 className="text-lg font-medium text-gray-800 mb-4">Upcoming</h3>
            
            <div className="space-y-4">
              {events.map((event, index) => (
                <div key={index} className="border-l-2 border-indigo-500 pl-3 py-1">
                  <div className="text-xs text-red-500 mb-1">{event.time}</div>
                  <div className="text-sm font-medium text-gray-800">{event.title}</div>
                  
                  {event.tags && (
                    <div className="flex space-x-2 mt-2">
                      {event.tags.map((tag, tagIndex) => (
                        <span key={tagIndex} className="text-xs px-2 py-1 bg-gray-100 text-gray-600 rounded-full">
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                  
                  {event.location && (
                    <div className="mt-2 h-16 bg-gray-100 rounded-modern flex items-center justify-center text-2xl">
                      {event.location}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          
          {/* Progress widget */}
          <div className="dashboard-card">
            <h3 className="text-lg font-medium text-gray-800 mb-2">{progressData.label}</h3>
            <div className="text-2xl font-bold text-gray-800 mb-3">{progressData.progress}%</div>
            
            {/* Progress bar */}
            <div className="h-2 w-full bg-gray-200 rounded-full mb-3">
              <div 
                className="h-full bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full" 
                style={{ width: `${progressData.progress}%` }}
              ></div>
            </div>
            
            <div className="text-sm text-gray-500">{progressData.subtitle}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard; 